import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import Star from '@material-ui/icons/Star';

import { FilterIcon } from '../../../../images/icons/WrapSvg';

import FilterMenu from './FilterMenu';

function toolbar(handleFilter, nofiltered) {
    const aux = [];
    aux.push(
        <FilterIcon
            disabled
            key={'hide-menu-toolbar'}
            className="hand"
            color={nofiltered ? 'primary' : 'secondary'}
            onClick={handleFilter}
        />,
    );
    return aux;
}

class ListValues extends React.Component {

    state = {
        error: undefined,
        report_sts: undefined,
        open: false,
        from: undefined,
        to: undefined,
        minimum: 1,
        maximun: 5
    };


    componentDidMount() {
        const { from, to } = this.state;
        const tools = [toolbar(this.handleFilter, !from && !to)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { report_sts } = props;
        if (report_sts !== state.report_sts) {
            state.report_sts = report_sts;
            state.local = report_sts && report_sts.local ? report_sts.local : undefined;
            state.from = report_sts && report_sts.from ? report_sts.from : undefined;
            state.to = report_sts && report_sts.to ? report_sts.to : undefined;
            state.name = report_sts && report_sts.name ? report_sts.name : undefined;
            state.data = report_sts && report_sts.values ? report_sts.values : [];
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleFilter = (event) => {
        this.setState({ open: true });
    }

    handleCloseFilter = (input_from, input_to, minimum, maximun) => {
        const { local, name, from, to } = this.state;


        if (from !== input_from || to !== input_to) {
            this.props
                .loadSTS(
                    local,
                    input_from,
                    input_to,
                    name
                )
                .then(() => this.props.history.push('/reports/sts/result'))
                .catch((error) => {
                    this.setState({ error: error.message });
                });
        }

        this.setState({ open: false, from: input_from, to: input_to, minimum: parseInt(minimum, 10), maximun: parseInt(maximun, 10) });
        const tools = [toolbar(this.handleFilter, !from && !to && minimum === 1 && minimum === 5)];
        this.props.setTools(tools);
    }

    render() {
        const { data, open, name, from, to, minimum, maximun } = this.state;
        const media = Math.round((data.reduce((total, item) => { total += item.puntuacion; return total }, 0) / data.length) * 100) / 100;
        console.log(from, to, minimum, maximun);
        return (
            <div
                className={'width100 padding_borders showbar overflow_x_scroll overflow_y_scroll'}
                onScroll={this.handleScroll}
            >
                {!!media &&
                    <div className="flex_auto_row padding_borders center">
                        <span className="barlow_medium c_bluish margin_right_24">{name}</span>
                        <Star className={"c_golden_yellow margin_right_6 barlowcondensed_light_number_medium"} />
                        <div className={"barlowcondensed_semibold_percentage  " + (media > 3 ? "c_pea" : "c_lipstick")}>{media}</div>
                    </div>
                }
                {data &&
                    data.length > 0 &&
                    data
                        .filter((f) => f.puntuacion >= minimum && f.puntuacion <= maximun)
                        .sort((a, b) => a.fecha > b.fecha ? -1 : 1)
                        .map((i) => {
                            return <div key={randomstring()} className=" flex_auto_row margin_bottom_12 padding_borders_flat bg_white boxShadow align_center" >
                                <div className="flex_auto_row center barlow_regular_textwrap">
                                    {i.puntuacion}
                                    <Star className={"c_golden_yellow margin_left_12 margin_right_24"} />
                                </div>
                                <div className="flex_auto_row c_dark_grey_blue margin_right_24 barlow_italic_medium nowrap"> {i.fecha} </div>
                                <div className="flex_full_row c_bluish margin_right_24 barlow_regular_textwrap"> {i.comentario} </div>
                            </div>
                        })}
                {open &&
                    <FilterMenu {...this.props} from={from} to={to} minimum={minimum} maximun={maximun} onClose={this.handleCloseFilter} />
                }
            </div>
        );
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListValues);



// WEBPACK FOOTER //
// ./src/components/complex/reports/sts/List.js